module.exports = __webpack_public_path__ + "img/tsinghua_anniversary-20160423-4-768x1024.af5e3b84.jpg";